import { browserHistory } from 'react-router';
import { delay, call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import * as apiList from '../../services/list/api_list';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import { LIST } from '../../constants/constant_doc_types';

export function* fetchListRecordsSaga(app) {
  yield takeLatest('FETCH_LIST_RECORD', callFetchListRecord, app);
}

function* callFetchListRecord(app, action) {
  const { filters, silent } = action;

  try {
    yield common.showProgressListTable(silent);

    const dataParams = {
      filters,
      list_type: LIST,
    };
    const tableData = yield call(apiCommon.getDocs, app, dataParams);

    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

export function* fetchListForEditSaga(app) {
  yield takeEvery('FETCH_LIST_FOR_EDIT', callFetchListForEdit, app);
}

function* callFetchListForEdit(app, action) {
  const { id, silent } = action;

  try {
    if (id) {
      yield common.showProgressDataById(silent);

      const params = { id };
      const doc = yield call(apiList.fetchListById, app, params);

      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error: error });
  }
}

export function* saveListSaga(app) {
  yield takeLatest('SAVE_LIST', callSaveList, app);
}

function* callSaveList(app, action) {
  const { tenant, user } = yield select();
  const { data } = action;

  try {
    yield put({ type: 'SAVE_RECORD_INPROGRESS' });

    const params = { data, tenant, user };
    const result = yield call(apiList.saveList, app, params);

    yield call(callFetchListForEdit, app, {
      id: result.id,
      silent: true,
    });

    browserHistory.push(`/admin/list/edit/${result.id}`);

    yield common.doneSaveRecord(result, 'List was saved');
  } catch (e) {
    yield common.showErrorSaveRecord(e);
  }
}

export function* deleteListSaga(app) {
  yield takeEvery('DELETE_LIST', callDeleteList, app);
}

function* callDeleteList(app, action) {
  const { tenant, user } = yield select();
  const { id } = action;

  try {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });

    const params = { tenant, user, id };

    yield call(apiList.deleteList, app, params);
    yield put({
      type: 'DELETE_RECORD_DONE',
      payload: { id, docType: LIST },
    });
    yield delay(2000);

    browserHistory.push('/admin/list');
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}
